import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import TerminalActivitylogService from "../../app/data/terminal-summary/terminalsummaryService";
import { initialTerminalActivitylogState } from "./ActivityLogState";

const terminalActivitylogService = TerminalActivitylogService.getInstance();

export const terminalActivitylogSlice = createSlice({
    name: "terminalActivitylog",
    initialState: initialTerminalActivitylogState,
    reducers: {
        resetTerminalActivityLog: (state) => initialTerminalActivitylogState,
        requestStarted: (state, { payload }) => {
            if (payload === "GET_ACTIVITY_LOGS_PORTION") {
                state.fetchPortionStarted = true;
            } else {
                state.requestStarted = true;
            }
            state.requestSucceed = false;
            state.requestFailed = false;
            state.requestCreator = payload;
            state.requestError = "";
        },
        requestSucceed: (state) => {
            state.requestStarted = false;
            state.fetchPortionStarted = false;
            state.requestSucceed = true;
            state.requestFailed = false;
        },
        requestFailed: (state, { payload }) => {
            state.requestStarted = false;
            state.requestSucceed = false;
            state.requestFailed = true;
            state.requestError = payload;
        },
        setTerminalActivitylogRequest: (state, { payload }) => {
            state.terminalActivityLogsRequest = {
                page: payload.page,
                last: payload.last
            }
        },
        clearTerminalActivitylogList: (state) => {
            state.terminalActivityLogs = [];
        },
        setActivityLog: (state, { payload }) => {
            state.terminalActivityLogs = payload;
        },
        addActivityLog: (state, { payload }) => {
            state.terminalActivityLogs = [...state.terminalActivityLogs, ...payload];
        },
        clearActivityLog: (state) => {
            state.terminalActivityLogs = [];
        },
        setActivityLogRequest: (state, { payload }) => {
            state.terminalActivityLogsRequest = {
                page: payload.page,
                last: payload.last
            }
        },
    }
});

export const {
    requestSucceed,
    requestFailed,
    requestStarted,
    setActivityLog,
    addActivityLog,
    setTerminalActivitylogRequest,
    clearTerminalActivitylogList,
    clearActivityLog,
    setActivityLogRequest
} = terminalActivitylogSlice.actions;

export const terminalActivitylogSelector = (state: IState) => state.terminalActivitylog;

export const STATIC_ACTIVITY_LOG_ACTION_OPTIONS = [
    { id: "CREATE", name: "CREATE" },
    { id: "UPDATE", name: "UPDATE" },
    { id: "DELETE", name: "DELETE" }
];

export const getTerminalActivityLogList = (
    page?: number,
    search?: any,
    action?: any,
    dateFrom?: any,
    dateTo?: any,
): AppThunk => async (dispatch) => {
    dispatch(requestStarted(page ? "GET_ACTIVITY_LOGS_PORTION" : "GET_ACTIVITY_LOGS"));

    const args = [];
    if (page !== undefined) args.push(page);
    if (search !== undefined) args.push(search);
    if (action !== undefined) args.push(action);
    if (dateFrom !== undefined) args.push(dateFrom);
    if (dateTo !== undefined) args.push(dateTo);

    const response = await terminalActivitylogService.getTerminalActivityLogList(...args);
    if (response.isCancel?.()) return;
    if (response.ok()) {
        dispatch(page ? addActivityLog(response.data?.content) : setActivityLog(response.data?.content));
        dispatch(setActivityLogRequest({
            page: response.data?.pageable.pageNumber,
            last: response.data?.last
        }));
        dispatch(requestSucceed());
    } else {
        dispatch(requestFailed(response.getError ? response.getError() : "Error"));
    }
}

const teminalActivityLogReducer = terminalActivitylogSlice.reducer;
export default teminalActivityLogReducer;
